import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// features
import { socketTrailerActivityStatusReceived } from '../sockets/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature trailer-activity
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  itemList: {},
  loading: false,
};

const initialPagination = {
  limit: 20,
  offset: 0,
};

const setListLoading = (state, loading) => (
  P.$set('loading', loading, state)
);

const getItemListSuccess = (state, data) => P.$set(
  'itemList',
  R.compose(
    G.indexByGuid,
    G.mapIndexed((item, index) => ({
      ...item,
      index,
      selected: false,
      expanded: false,
    })),
  )(R.or(data, [])),
  state,
);

const selectItem = (state, guid) => (
  P.$toggle(`itemList.${guid}.selected`, state)
);

const createTrailerActivityListSuccess = (state, data) => {
  const index = R.compose(
    R.length,
    R.values,
    R.prop('itemList'),
  )(state);

  return P.$set(
    `itemList.${G.getGuidFromObject(data)}`,
    {
      ...data,
      index,
      selected: false,
      expanded: false,
    },
    state,
  );
};

const updateTrailerActivityListSuccess = (state, data) => (
  P.$set(
    'itemList',
    R.map(
      (item) => {
        if (R.eqProps(GC.FIELD_GUID, data, item)) return { ...item, ...data };

        return item;
      },
      state.itemList,
    ),
    state,
  )
);

const deleteItemSuccess = (state, guid) => (
  P.$drop(`itemList.${guid}`, state)
);

const toggleDetails = (state, { guid }) => P.$toggle(`itemList.${guid}.expanded`, state);

const resetTrailerActivityListDetails = (state, guid) => (
  P.$set(
    `itemList.${guid}.details`,
    null,
    state,
  )
);

const getDetailsByRowGuidSuccess = (state, data) => {
  const { results, totalCount, trailerActivityListGuid } = data;

  const details = R.path(['itemList', trailerActivityListGuid, 'details'], state);

  const pagination = R.pathOr(initialPagination, ['pagination'], details);

  const itemList = R.map(
    (item) => R.assoc('selected', R.propOr(false, 'selected', item), item),
    R.concat(R.pathOr([], ['itemList'], details), results),
  );

  const newOffset = R.add(pagination.offset, pagination.limit);

  return P.$set(
    `itemList.${trailerActivityListGuid}.details`,
    {
      itemList,
      totalCount,
      pagination: {
        limit: 20,
        offset: G.ifElse(R.gt(totalCount, newOffset), newOffset, totalCount),
      },
    },
    state,
  );
};

const addTrailersToActivityListSuccess = (state, trailerActivityListGuid) => (
  P.$all(
    P.$set(`itemList.${trailerActivityListGuid}.details`, null),
    P.$set(`itemList.${trailerActivityListGuid}.expanded`, false),
    state,
  )
);

const selectTrailer = (state, data) => {
  const { guid, trailerActivityListGuid } = data;

  const itemList = R.path(['itemList', trailerActivityListGuid, 'details', 'itemList'], state);

  let list;

  if (R.isNil(guid)) {
    const value = R.not(R.all(R.prop('selected'), itemList));

    list = R.map(
      R.assoc('selected', value),
      itemList,
    );
  } else {
    list = R.map((item) => {
      if (R.propEq(guid, GC.FIELD_GUID, item)) return P.$toggle('selected', item);

      return item;
    }, itemList);
  }


  return P.$set(`itemList.${trailerActivityListGuid}.details.itemList`, list, state);
};

const trailerActivityStatusReceived = (state, data) => {
  const { guid, status, lastSynchronizedDate } = data;

  const exist = R.path(['itemList', guid], state);

  if (G.isNotNil(exist)) {
    return P.$set(`itemList.${guid}`, { ...exist, status, lastSynchronizedDate }, state);
  }

  return state;
};

const updateTrailerCommentsSuccess = (state, data) => {
  const { guid, comments, trailerActivityListGuid } = data;

  const trailerList = R.path(['itemList', trailerActivityListGuid, 'details', 'itemList'], state);

  if (G.isNilOrEmpty(trailerList)) return state;

  return P.$set(
    `itemList.${trailerActivityListGuid}.details.itemList`,
    R.map((trailer) => {
      if (R.propEq(guid, GC.FIELD_GUID, trailer)) return { ...trailer, comments };

      return trailer;
    }, trailerList),
    state,
  );
};

export default createReducer({
  [A.selectItem]: selectItem,
  [A.toggleDetails]: toggleDetails,
  [A.selectTrailer]: selectTrailer,
  [A.setListLoading]: setListLoading,
  [A.deleteItemSuccess]: deleteItemSuccess,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.getDetailsByRowGuidSuccess]: getDetailsByRowGuidSuccess,
  [A.updateTrailerCommentsSuccess]: updateTrailerCommentsSuccess,
  [A.resetTrailerActivityListDetails]: resetTrailerActivityListDetails,
  [socketTrailerActivityStatusReceived]: trailerActivityStatusReceived,
  [A.addTrailersToActivityListSuccess]: addTrailersToActivityListSuccess,
  [A.createTrailerActivityListSuccess]: createTrailerActivityListSuccess,
  [A.updateTrailerActivityListSuccess]: updateTrailerActivityListSuccess,
}, initialState);
